module.exports = __webpack_public_path__ + "static/jon-9c25597fb3b0281a15e097d2bf8a207f.png";